<template>
  <div class="w-full flex justify-center gap-6">
    <!-- Mouse Color Picker -->
    <div
      class="w-80 bg-white/80 dark:bg-neutral-800/80 backdrop-blur-xl rounded-3xl p-4 shadow-xl flex gap-4"
    >
      <div
        class="w-24 h-24 rounded-2xl bg-linear-to-br from-green-400 via-blue-500 to-purple-600 shadow-inner relative"
      >
        <div
          class="absolute top-2 right-2 w-3 h-3 rounded-full border-2 border-white bg-transparent"
        ></div>
      </div>
      <div class="flex-1 flex flex-col justify-between">
        <div>
          <div class="text-xs text-neutral-500 mb-1">RGB (鼠标)</div>
          <div class="flex gap-2">
            <input
              v-model="rgb.r"
              class="w-12 bg-neutral-100 dark:bg-neutral-700 rounded px-1 text-center text-xs"
            />
            <input
              v-model="rgb.g"
              class="w-12 bg-neutral-100 dark:bg-neutral-700 rounded px-1 text-center text-xs"
            />
            <input
              v-model="rgb.b"
              class="w-12 bg-neutral-100 dark:bg-neutral-700 rounded px-1 text-center text-xs"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Mouse Lighting Modes (Fewer/Different) -->
    <div
      class="flex-1 max-w-3xl bg-white/80 dark:bg-neutral-800/80 backdrop-blur-xl rounded-3xl p-6 shadow-xl relative"
    >
      <div class="text-sm font-medium mb-4 text-neutral-500">鼠标灯光模式</div>
      <div class="grid grid-cols-4 gap-3">
        <div
          v-for="mode in lightingModes"
          :key="mode.id"
          class="flex items-center gap-2 p-2 rounded-xl border border-transparent hover:bg-white dark:hover:bg-neutral-700 cursor-pointer transition-all hover:shadow-sm hover:border-neutral-200 dark:hover:border-neutral-600"
          :class="{
            'bg-white dark:bg-neutral-700 shadow-sm border-neutral-200 dark:border-neutral-600':
              currentMode === mode.id,
          }"
          @click="currentMode = mode.id"
        >
          <Icon :icon="mode.icon" class="size-4 text-neutral-600 dark:text-neutral-400" />
          <span class="text-xs font-medium">{{ mode.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { Icon } from '@rapoo/element'

  const rgb = ref({ r: 0, g: 255, b: 0 })
  const currentMode = ref(1)

  // Mouse modes might differ from Keyboard
  const lightingModes = [
    { id: 1, name: '呼吸模式', icon: 'Lighting-Wireframe-Breathing' },
    { id: 2, name: '幻彩流动', icon: 'Lighting-Wireframe-Ripple' },
    { id: 3, name: '常亮模式', icon: 'Lighting-Wireframe-Light' },
    { id: 4, name: '反应模式', icon: 'Lighting-Wireframe-Shadow' },
    { id: 5, name: '关闭', icon: 'System-Wireframe-Close' },
  ]
</script>
